import React from 'react'
import styled from 'styled-components'
import ApartmentOutlinedIcon from '@mui/icons-material/ApartmentOutlined'
import { radius } from 'features/dashboard/tokens'

const EstateFileBuildingSharesChip = ({ count, onClick }) => {
  if (!count) return null

  return (
    <Chip type='button' onClick={onClick} title='See the Building Passports this is shared with'>
      <ApartmentOutlinedIcon style={{ fontSize: 13 }} />
      {count} Building Passport{count === 1 ? '' : 's'}
    </Chip>
  )
}

export default EstateFileBuildingSharesChip

const Chip = styled.button`
  display: inline-flex;
  align-items: center;
  align-self: flex-start;
  gap: 5px;
  margin-top: 8px;
  padding: 4px 10px;
  border: none;
  border-radius: ${radius.pill};
  background: #e6f7f9;
  color: #2aa6b3;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
  transition: background 160ms ease;

  &:hover {
    background: #d3f0f2;
  }

  &:focus-visible {
    outline: 2px solid #33becc;
    outline-offset: 1px;
  }
`
